import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"luminance"}
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-rule": "evenodd",
        d: "M3 3h18v18H3z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#0A1121",
        "fill-rule": "evenodd",
        d: "M19.914 8.278c-.3 1.368-1.476 2.47-2.86 2.68A4 4 0 0 1 16.5 11a3.5 3.5 0 0 1-.941-.145 3.5 3.5 0 0 1-.971-.443l-.728.728L5 20l-1-1 8.86-8.86.73-.73a3.4 3.4 0 0 1-.46-.954 3.6 3.6 0 0 1-.088-1.51c.21-1.384 1.312-2.56 2.68-2.86.26-.057.522-.086.778-.086.316 0 .629.044.946.14l-2.653 2.653a1.7 1.7 0 0 0-.494 1.265A1.688 1.688 0 0 0 15.942 9.7c.019 0 .038.006.058.006.456 0 .885-.178 1.207-.5l2.663-2.64c.157.553.172 1.128.044 1.71m.918-1.982a1.01 1.01 0 0 0-.978-.741c-.248 0-.5.092-.701.293L16.5 8.5a.705.705 0 0 1-1 0 .707.707 0 0 1 0-1l2.653-2.653c.545-.545.294-1.468-.447-1.68A4.4 4.4 0 0 0 16.5 3q-.485-.001-.992.109c-1.778.39-3.182 1.888-3.454 3.687a4.5 4.5 0 0 0 .294 2.442l-9.055 9.055a1 1 0 0 0 0 1.414l1 1A1 1 0 0 0 5 21a1 1 0 0 0 .707-.293l9.06-9.06a4.5 4.5 0 0 0 2.437.299c1.799-.272 3.297-1.676 3.687-3.454a4.5 4.5 0 0 0-.059-2.197",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]))]))
}
export default { render: render }